import {Inject, Injectable} from '@angular/core';
import {LOCAL_STORAGE, StorageService, WebStorageService} from 'angular-webstorage-service';
import {HttpService} from './http.service';
import {AppResponse} from '../_modals/app.response';
import {Observable} from 'rxjs';

@Injectable()
export class UtilService {


    constructor(private httpService: HttpService, @Inject(LOCAL_STORAGE) private storage: StorageService) {
    }

    getGrievanceState(): Observable<AppResponse> {
        return this.httpService.get<AppResponse>('casemanager/grievance_state/');
    }

    getQualifier(ai: number): Observable<AppResponse> {

        return this.httpService.get<AppResponse>('mnews_qualifier/?ai=' + ai + '&limit=0');
    }

    getCategory(ai: number): Observable<AppResponse> {

        return this.httpService.get<AppResponse>('mnews_category/?ai=' + ai + '&limit=0');
    }

    getFormat(ai: number): Observable<AppResponse> {

        return this.httpService.get<AppResponse>('mnews_format/?ai=' + ai + '&limit=0');
    }

    getCampaign(ai: number): Observable<AppResponse> {

        return this.httpService.get<AppResponse>('mnews_qualifier/?ai=' + ai + '&limit=0');
    }

    getCampaignCategory(ai: number): Observable<AppResponse> {

        return this.httpService.get<AppResponse>('mnews_qualifier/?ai=' + ai + '&limit=0');
    }

    getLocation(ai: number): Observable<AppResponse> {

        return this.httpService.get<AppResponse>('location_location/?ai=' + ai + '&limit=0');
    }

    getOccupation(): Observable<AppResponse> {
        return this.httpService.get<AppResponse>('mnews_occupation/?limit=0');
    }

    getGender(): Observable<AppResponse> {

        return this.httpService.get<AppResponse>('mnews_gender/?limit=0');
    }

    getAgeGroup(): Observable<AppResponse> {
        return this.httpService.get<AppResponse>('mnews_age_group/?limit=0');
    }

    getAppDetails(ai_id: number): Observable<any> {
        return this.httpService.get<AppResponse>('app_instance/' + ai_id + '/?limit=0');
    }

    getHandler(ai_id: number): Observable<any> {
        return this.httpService.get<AppResponse>('casemanager/handler/getHandler/?ai_id=' + ai_id + '&format=json');
    }

    getAllTags(ai_id: number): Observable<any> {
        return this.httpService.get('mnews_news/get_all_tags/?ai_id=' + ai_id + '&format=json');
    }

    getProfile(ai_id: number): Observable<any> {
        return this.httpService.get('casemanager/moderator/get_profile/?ai_id=' + ai_id + '&actionee=MODERATOR&format=json');
    }


    getProperties(ai_id: number): Observable<any> {
        return this.httpService.get('casemanager/properties/get_by_casemanager_ai/?ai_id=' + ai_id );
    }
}
